import {
  Companion_getInstance30idiynnpnbn2 as Companion_getInstance,
  PendingItemChange1hwhwykx2kyit as PendingItemChange,
} from './databaseModels.mjs';
import {
  properties1qnxlk10mmfrs as properties,
  get_serializableAnnotations132wwdaanmitj as get_serializableAnnotations,
  SerializableProperty3ugfzrmvjw266 as SerializableProperty,
} from '../../../lightning-server-shared/com/lightningkite/serialization/SerializableProperty.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { Companion_instance1i4n4o7mef2za as Companion_instance } from '../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/Clock.mjs';
import { get_default1l68fybpthpme as get_default } from '../../../lightning-server-shared/com/lightningkite/DefaultClock.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Instant3cn81rq2kpflk as Instant } from '../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/Instant.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import {
  UUID21wrnrlmk5y1y as UUID,
  Companion_getInstance3n9as6ds1py67 as Companion_getInstance_0,
} from '../../../lightning-server-shared/com/lightningkite/UUID.js.mjs';
import {
  MonetaryValue3pm7jom4inigc as MonetaryValue,
  AccessInfoj60d6hx1qs8r as AccessInfo,
  AccessAndFeedback14j91frzc8fa0 as AccessAndFeedback,
} from './supportModels.mjs';
import { emptySetcxexqki71qfa as emptySet } from '../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
import { KtSetjrjc7fhfd6b9 as KtSet } from '../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_created(_this__u8e3s4) {
  return _this__u8e3s4.prop(PendingItemChange_created_getInstance());
}
function get_changeRequest(_this__u8e3s4) {
  return _this__u8e3s4.prop(PendingItemChange_changeRequest_getInstance());
}
function get_itemNumber(_this__u8e3s4) {
  return _this__u8e3s4.prop(PendingItemChange_itemNumber_getInstance());
}
function get_priceChange(_this__u8e3s4) {
  return _this__u8e3s4.prop(PendingItemChange_priceChange_getInstance());
}
function get_updatedDescription(_this__u8e3s4) {
  return _this__u8e3s4.prop(PendingItemChange_updatedDescription_getInstance());
}
function get_project(_this__u8e3s4) {
  return _this__u8e3s4.prop(PendingItemChange_project_getInstance());
}
function preparePendingItemChangeFields() {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var props = [PendingItemChange__id_getInstance(), PendingItemChange_project_getInstance(), PendingItemChange_changeRequest_getInstance(), PendingItemChange_itemId_getInstance(), PendingItemChange_updatedDescription_getInstance(), PendingItemChange_priceChange_getInstance(), PendingItemChange_cancelled_getInstance(), PendingItemChange_accepted_getInstance(), PendingItemChange_approved_getInstance(), PendingItemChange_denied_getInstance(), PendingItemChange_withdrawn_getInstance(), PendingItemChange_created_getInstance(), PendingItemChange_itemNumber_getInstance(), PendingItemChange_readBy_getInstance(), PendingItemChange_published_getInstance()];
  var tmp = Companion_getInstance().m2a();
  properties(tmp, (it) => props);
}
function PendingItemChange_created$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(11);
}
function PendingItemChange_created$_get_name_$ref_9e8rsg() {
  return (p0) => p0.k20();
}
function PendingItemChange_created$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[11];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function PendingItemChange_created$_get_serializer_$ref_j0fvcn() {
  return (p0) => p0.j2j();
}
function PendingItemChange_created$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(11);
}
function PendingItemChange_created$_get_annotations_$ref_xsnfdn() {
  return (p0) => p0.bz();
}
var PendingItemChange_createdClass;
function PendingItemChange_created() {
  if (PendingItemChange_createdClass === VOID) {
    class $ {
      constructor() {
        PendingItemChange_created_instance = this;
        var tmp = this;
        tmp.w71_1 = lazy(PendingItemChange_created$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.x71_1 = lazy(PendingItemChange_created$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.y71_1 = lazy(PendingItemChange_created$annotations$delegate$lambda);
        var tmp_2 = this;
        // Inline function 'com.lightningkite.now' call
        tmp_2.z71_1 = get_default(Companion_instance).d1m();
        this.a72_1 = 'now()';
      }
      k20() {
        var tmp0 = this.w71_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, PendingItemChange_created$_get_name_$ref_9e8rsg(), null);
        return tmp0.f2();
      }
      b72(receiver) {
        return receiver.n72_1;
      }
      m2j(receiver) {
        return this.b72(receiver instanceof PendingItemChange() ? receiver : THROW_CCE());
      }
      r72(receiver, value) {
        return receiver.s72(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof PendingItemChange() ? receiver : THROW_CCE();
        return this.r72(tmp, value instanceof Instant() ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.x71_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, PendingItemChange_created$_get_serializer_$ref_j0fvcn(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.y71_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, PendingItemChange_created$_get_annotations_$ref_xsnfdn(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'PendingItemChange_created', VOID, VOID, [SerializableProperty()]);
    PendingItemChange_createdClass = $;
  }
  return PendingItemChange_createdClass;
}
var PendingItemChange_created_instance;
function PendingItemChange_created_getInstance() {
  if (PendingItemChange_created_instance === VOID)
    new (PendingItemChange_created())();
  return PendingItemChange_created_instance;
}
function PendingItemChange_changeRequest$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(2);
}
function PendingItemChange_changeRequest$_get_name_$ref_w73007() {
  return (p0) => p0.k20();
}
function PendingItemChange_changeRequest$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[2];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function PendingItemChange_changeRequest$_get_serializer_$ref_19y6he() {
  return (p0) => p0.j2j();
}
function PendingItemChange_changeRequest$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(2);
}
function PendingItemChange_changeRequest$_get_annotations_$ref_ngqigi() {
  return (p0) => p0.bz();
}
var PendingItemChange_changeRequestClass;
function PendingItemChange_changeRequest() {
  if (PendingItemChange_changeRequestClass === VOID) {
    class $ {
      constructor() {
        PendingItemChange_changeRequest_instance = this;
        var tmp = this;
        tmp.t72_1 = lazy(PendingItemChange_changeRequest$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.u72_1 = lazy(PendingItemChange_changeRequest$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.v72_1 = lazy(PendingItemChange_changeRequest$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.t72_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, PendingItemChange_changeRequest$_get_name_$ref_w73007(), null);
        return tmp0.f2();
      }
      b72(receiver) {
        return receiver.e72_1;
      }
      m2j(receiver) {
        return this.b72(receiver instanceof PendingItemChange() ? receiver : THROW_CCE());
      }
      w72(receiver, value) {
        return receiver.s72(VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof PendingItemChange() ? receiver : THROW_CCE();
        return this.w72(tmp, value instanceof UUID() ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.u72_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, PendingItemChange_changeRequest$_get_serializer_$ref_19y6he(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.v72_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, PendingItemChange_changeRequest$_get_annotations_$ref_ngqigi(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'PendingItemChange_changeRequest', VOID, VOID, [SerializableProperty()]);
    PendingItemChange_changeRequestClass = $;
  }
  return PendingItemChange_changeRequestClass;
}
var PendingItemChange_changeRequest_instance;
function PendingItemChange_changeRequest_getInstance() {
  if (PendingItemChange_changeRequest_instance === VOID)
    new (PendingItemChange_changeRequest())();
  return PendingItemChange_changeRequest_instance;
}
function PendingItemChange_itemNumber$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(12);
}
function PendingItemChange_itemNumber$_get_name_$ref_1kfi8e() {
  return (p0) => p0.k20();
}
function PendingItemChange_itemNumber$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[12];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function PendingItemChange_itemNumber$_get_serializer_$ref_47l3d7() {
  return (p0) => p0.j2j();
}
function PendingItemChange_itemNumber$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(12);
}
function PendingItemChange_itemNumber$_get_annotations_$ref_rmra3r() {
  return (p0) => p0.bz();
}
var PendingItemChange_itemNumberClass;
function PendingItemChange_itemNumber() {
  if (PendingItemChange_itemNumberClass === VOID) {
    class $ {
      constructor() {
        PendingItemChange_itemNumber_instance = this;
        var tmp = this;
        tmp.x72_1 = lazy(PendingItemChange_itemNumber$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.y72_1 = lazy(PendingItemChange_itemNumber$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.z72_1 = lazy(PendingItemChange_itemNumber$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.x72_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, PendingItemChange_itemNumber$_get_name_$ref_1kfi8e(), null);
        return tmp0.f2();
      }
      b72(receiver) {
        return receiver.o72_1;
      }
      m2j(receiver) {
        return this.b72(receiver instanceof PendingItemChange() ? receiver : THROW_CCE());
      }
      a73(receiver, value) {
        return receiver.s72(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof PendingItemChange() ? receiver : THROW_CCE();
        return this.a73(tmp, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.y72_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, PendingItemChange_itemNumber$_get_serializer_$ref_47l3d7(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.z72_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, PendingItemChange_itemNumber$_get_annotations_$ref_rmra3r(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'PendingItemChange_itemNumber', VOID, VOID, [SerializableProperty()]);
    PendingItemChange_itemNumberClass = $;
  }
  return PendingItemChange_itemNumberClass;
}
var PendingItemChange_itemNumber_instance;
function PendingItemChange_itemNumber_getInstance() {
  if (PendingItemChange_itemNumber_instance === VOID)
    new (PendingItemChange_itemNumber())();
  return PendingItemChange_itemNumber_instance;
}
function PendingItemChange_priceChange$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(5);
}
function PendingItemChange_priceChange$_get_name_$ref_kbgyov() {
  return (p0) => p0.k20();
}
function PendingItemChange_priceChange$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[5];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function PendingItemChange_priceChange$_get_serializer_$ref_5ppid4() {
  return (p0) => p0.j2j();
}
function PendingItemChange_priceChange$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(5);
}
function PendingItemChange_priceChange$_get_annotations_$ref_iz1mto() {
  return (p0) => p0.bz();
}
var PendingItemChange_priceChangeClass;
function PendingItemChange_priceChange() {
  if (PendingItemChange_priceChangeClass === VOID) {
    class $ {
      constructor() {
        PendingItemChange_priceChange_instance = this;
        var tmp = this;
        tmp.b73_1 = lazy(PendingItemChange_priceChange$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.c73_1 = lazy(PendingItemChange_priceChange$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.d73_1 = lazy(PendingItemChange_priceChange$annotations$delegate$lambda);
        this.e73_1 = null;
        this.f73_1 = 'null';
      }
      k20() {
        var tmp0 = this.b73_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, PendingItemChange_priceChange$_get_name_$ref_kbgyov(), null);
        return tmp0.f2();
      }
      g73(receiver) {
        return receiver.h72_1;
      }
      m2j(receiver) {
        var tmp = this.g73(receiver instanceof PendingItemChange() ? receiver : THROW_CCE());
        return tmp == null ? null : new (MonetaryValue())(tmp);
      }
      h73(receiver, value) {
        return receiver.s72(VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof PendingItemChange() ? receiver : THROW_CCE();
        var tmp_0;
        if (value == null ? true : value instanceof MonetaryValue()) {
          var tmp_1 = value;
          tmp_0 = tmp_1 == null ? null : tmp_1.a5s_1;
        } else {
          tmp_0 = THROW_CCE();
        }
        return this.h73(tmp, tmp_0);
      }
      j2j() {
        var tmp0 = this.c73_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, PendingItemChange_priceChange$_get_serializer_$ref_5ppid4(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.d73_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, PendingItemChange_priceChange$_get_annotations_$ref_iz1mto(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'PendingItemChange_priceChange', VOID, VOID, [SerializableProperty()]);
    PendingItemChange_priceChangeClass = $;
  }
  return PendingItemChange_priceChangeClass;
}
var PendingItemChange_priceChange_instance;
function PendingItemChange_priceChange_getInstance() {
  if (PendingItemChange_priceChange_instance === VOID)
    new (PendingItemChange_priceChange())();
  return PendingItemChange_priceChange_instance;
}
function PendingItemChange_updatedDescription$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(4);
}
function PendingItemChange_updatedDescription$_get_name_$ref_vpq9ir() {
  return (p0) => p0.k20();
}
function PendingItemChange_updatedDescription$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[4];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function PendingItemChange_updatedDescription$_get_serializer_$ref_rt46zq() {
  return (p0) => p0.j2j();
}
function PendingItemChange_updatedDescription$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(4);
}
function PendingItemChange_updatedDescription$_get_annotations_$ref_6efpgi() {
  return (p0) => p0.bz();
}
var PendingItemChange_updatedDescriptionClass;
function PendingItemChange_updatedDescription() {
  if (PendingItemChange_updatedDescriptionClass === VOID) {
    class $ {
      constructor() {
        PendingItemChange_updatedDescription_instance = this;
        var tmp = this;
        tmp.i73_1 = lazy(PendingItemChange_updatedDescription$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.j73_1 = lazy(PendingItemChange_updatedDescription$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.k73_1 = lazy(PendingItemChange_updatedDescription$annotations$delegate$lambda);
        this.l73_1 = null;
        this.m73_1 = 'null';
      }
      k20() {
        var tmp0 = this.i73_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, PendingItemChange_updatedDescription$_get_name_$ref_vpq9ir(), null);
        return tmp0.f2();
      }
      b72(receiver) {
        return receiver.g72_1;
      }
      m2j(receiver) {
        return this.b72(receiver instanceof PendingItemChange() ? receiver : THROW_CCE());
      }
      n73(receiver, value) {
        return receiver.s72(VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof PendingItemChange() ? receiver : THROW_CCE();
        return this.n73(tmp, (value == null ? true : typeof value === 'string') ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.j73_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, PendingItemChange_updatedDescription$_get_serializer_$ref_rt46zq(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.k73_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, PendingItemChange_updatedDescription$_get_annotations_$ref_6efpgi(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'PendingItemChange_updatedDescription', VOID, VOID, [SerializableProperty()]);
    PendingItemChange_updatedDescriptionClass = $;
  }
  return PendingItemChange_updatedDescriptionClass;
}
var PendingItemChange_updatedDescription_instance;
function PendingItemChange_updatedDescription_getInstance() {
  if (PendingItemChange_updatedDescription_instance === VOID)
    new (PendingItemChange_updatedDescription())();
  return PendingItemChange_updatedDescription_instance;
}
function PendingItemChange_project$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(1);
}
function PendingItemChange_project$_get_name_$ref_dnij4v() {
  return (p0) => p0.k20();
}
function PendingItemChange_project$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[1];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function PendingItemChange_project$_get_serializer_$ref_i9noco() {
  return (p0) => p0.j2j();
}
function PendingItemChange_project$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(1);
}
function PendingItemChange_project$_get_annotations_$ref_e66lmc() {
  return (p0) => p0.bz();
}
var PendingItemChange_projectClass;
function PendingItemChange_project() {
  if (PendingItemChange_projectClass === VOID) {
    class $ {
      constructor() {
        PendingItemChange_project_instance = this;
        var tmp = this;
        tmp.o73_1 = lazy(PendingItemChange_project$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.p73_1 = lazy(PendingItemChange_project$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.q73_1 = lazy(PendingItemChange_project$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.o73_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, PendingItemChange_project$_get_name_$ref_dnij4v(), null);
        return tmp0.f2();
      }
      b72(receiver) {
        return receiver.d72_1;
      }
      m2j(receiver) {
        return this.b72(receiver instanceof PendingItemChange() ? receiver : THROW_CCE());
      }
      w72(receiver, value) {
        return receiver.s72(VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof PendingItemChange() ? receiver : THROW_CCE();
        return this.w72(tmp, value instanceof UUID() ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.p73_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, PendingItemChange_project$_get_serializer_$ref_i9noco(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.q73_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, PendingItemChange_project$_get_annotations_$ref_e66lmc(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'PendingItemChange_project', VOID, VOID, [SerializableProperty()]);
    PendingItemChange_projectClass = $;
  }
  return PendingItemChange_projectClass;
}
var PendingItemChange_project_instance;
function PendingItemChange_project_getInstance() {
  if (PendingItemChange_project_instance === VOID)
    new (PendingItemChange_project())();
  return PendingItemChange_project_instance;
}
function PendingItemChange__id$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(0);
}
function PendingItemChange__id$_get_name_$ref_djifhe() {
  return (p0) => p0.k20();
}
function PendingItemChange__id$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[0];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function PendingItemChange__id$_get_serializer_$ref_si9fnt() {
  return (p0) => p0.j2j();
}
function PendingItemChange__id$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(0);
}
function PendingItemChange__id$_get_annotations_$ref_nkn5nx() {
  return (p0) => p0.bz();
}
var PendingItemChange__idClass;
function PendingItemChange__id() {
  if (PendingItemChange__idClass === VOID) {
    class $ {
      constructor() {
        PendingItemChange__id_instance = this;
        var tmp = this;
        tmp.r73_1 = lazy(PendingItemChange__id$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.s73_1 = lazy(PendingItemChange__id$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.t73_1 = lazy(PendingItemChange__id$annotations$delegate$lambda);
        this.u73_1 = Companion_getInstance_0().m2p();
        this.v73_1 = 'UUID.random()';
      }
      k20() {
        var tmp0 = this.r73_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, PendingItemChange__id$_get_name_$ref_djifhe(), null);
        return tmp0.f2();
      }
      b72(receiver) {
        return receiver.c72_1;
      }
      m2j(receiver) {
        return this.b72(receiver instanceof PendingItemChange() ? receiver : THROW_CCE());
      }
      w72(receiver, value) {
        return receiver.s72(value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof PendingItemChange() ? receiver : THROW_CCE();
        return this.w72(tmp, value instanceof UUID() ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.s73_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, PendingItemChange__id$_get_serializer_$ref_si9fnt(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.t73_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, PendingItemChange__id$_get_annotations_$ref_nkn5nx(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'PendingItemChange__id', VOID, VOID, [SerializableProperty()]);
    PendingItemChange__idClass = $;
  }
  return PendingItemChange__idClass;
}
var PendingItemChange__id_instance;
function PendingItemChange__id_getInstance() {
  if (PendingItemChange__id_instance === VOID)
    new (PendingItemChange__id())();
  return PendingItemChange__id_instance;
}
function PendingItemChange_itemId$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(3);
}
function PendingItemChange_itemId$_get_name_$ref_37ohk0() {
  return (p0) => p0.k20();
}
function PendingItemChange_itemId$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[3];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function PendingItemChange_itemId$_get_serializer_$ref_6eston() {
  return (p0) => p0.j2j();
}
function PendingItemChange_itemId$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(3);
}
function PendingItemChange_itemId$_get_annotations_$ref_1r6gt1() {
  return (p0) => p0.bz();
}
var PendingItemChange_itemIdClass;
function PendingItemChange_itemId() {
  if (PendingItemChange_itemIdClass === VOID) {
    class $ {
      constructor() {
        PendingItemChange_itemId_instance = this;
        var tmp = this;
        tmp.w73_1 = lazy(PendingItemChange_itemId$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.x73_1 = lazy(PendingItemChange_itemId$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.y73_1 = lazy(PendingItemChange_itemId$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.w73_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, PendingItemChange_itemId$_get_name_$ref_37ohk0(), null);
        return tmp0.f2();
      }
      b72(receiver) {
        return receiver.f72_1;
      }
      m2j(receiver) {
        return this.b72(receiver instanceof PendingItemChange() ? receiver : THROW_CCE());
      }
      w72(receiver, value) {
        return receiver.s72(VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof PendingItemChange() ? receiver : THROW_CCE();
        return this.w72(tmp, value instanceof UUID() ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.x73_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, PendingItemChange_itemId$_get_serializer_$ref_6eston(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.y73_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, PendingItemChange_itemId$_get_annotations_$ref_1r6gt1(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'PendingItemChange_itemId', VOID, VOID, [SerializableProperty()]);
    PendingItemChange_itemIdClass = $;
  }
  return PendingItemChange_itemIdClass;
}
var PendingItemChange_itemId_instance;
function PendingItemChange_itemId_getInstance() {
  if (PendingItemChange_itemId_instance === VOID)
    new (PendingItemChange_itemId())();
  return PendingItemChange_itemId_instance;
}
function PendingItemChange_cancelled$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(6);
}
function PendingItemChange_cancelled$_get_name_$ref_fuxwrd() {
  return (p0) => p0.k20();
}
function PendingItemChange_cancelled$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[6];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function PendingItemChange_cancelled$_get_serializer_$ref_js9s0() {
  return (p0) => p0.j2j();
}
function PendingItemChange_cancelled$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(6);
}
function PendingItemChange_cancelled$_get_annotations_$ref_xnclg() {
  return (p0) => p0.bz();
}
var PendingItemChange_cancelledClass;
function PendingItemChange_cancelled() {
  if (PendingItemChange_cancelledClass === VOID) {
    class $ {
      constructor() {
        PendingItemChange_cancelled_instance = this;
        var tmp = this;
        tmp.z73_1 = lazy(PendingItemChange_cancelled$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.a74_1 = lazy(PendingItemChange_cancelled$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.b74_1 = lazy(PendingItemChange_cancelled$annotations$delegate$lambda);
        this.c74_1 = false;
        this.d74_1 = 'false';
      }
      k20() {
        var tmp0 = this.z73_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, PendingItemChange_cancelled$_get_name_$ref_fuxwrd(), null);
        return tmp0.f2();
      }
      b72(receiver) {
        return receiver.i72_1;
      }
      m2j(receiver) {
        return this.b72(receiver instanceof PendingItemChange() ? receiver : THROW_CCE());
      }
      e74(receiver, value) {
        return receiver.s72(VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof PendingItemChange() ? receiver : THROW_CCE();
        return this.e74(tmp, (!(value == null) ? typeof value === 'boolean' : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.a74_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, PendingItemChange_cancelled$_get_serializer_$ref_js9s0(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.b74_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, PendingItemChange_cancelled$_get_annotations_$ref_xnclg(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'PendingItemChange_cancelled', VOID, VOID, [SerializableProperty()]);
    PendingItemChange_cancelledClass = $;
  }
  return PendingItemChange_cancelledClass;
}
var PendingItemChange_cancelled_instance;
function PendingItemChange_cancelled_getInstance() {
  if (PendingItemChange_cancelled_instance === VOID)
    new (PendingItemChange_cancelled())();
  return PendingItemChange_cancelled_instance;
}
function PendingItemChange_accepted$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(7);
}
function PendingItemChange_accepted$_get_name_$ref_4trpbb() {
  return (p0) => p0.k20();
}
function PendingItemChange_accepted$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[7];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function PendingItemChange_accepted$_get_serializer_$ref_2vka68() {
  return (p0) => p0.j2j();
}
function PendingItemChange_accepted$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(7);
}
function PendingItemChange_accepted$_get_annotations_$ref_21nmv8() {
  return (p0) => p0.bz();
}
var PendingItemChange_acceptedClass;
function PendingItemChange_accepted() {
  if (PendingItemChange_acceptedClass === VOID) {
    class $ {
      constructor() {
        PendingItemChange_accepted_instance = this;
        var tmp = this;
        tmp.f74_1 = lazy(PendingItemChange_accepted$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.g74_1 = lazy(PendingItemChange_accepted$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.h74_1 = lazy(PendingItemChange_accepted$annotations$delegate$lambda);
        this.i74_1 = null;
        this.j74_1 = 'null';
      }
      k20() {
        var tmp0 = this.f74_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, PendingItemChange_accepted$_get_name_$ref_4trpbb(), null);
        return tmp0.f2();
      }
      b72(receiver) {
        return receiver.j72_1;
      }
      m2j(receiver) {
        return this.b72(receiver instanceof PendingItemChange() ? receiver : THROW_CCE());
      }
      k74(receiver, value) {
        return receiver.s72(VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof PendingItemChange() ? receiver : THROW_CCE();
        return this.k74(tmp, (value == null ? true : value instanceof AccessInfo()) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.g74_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, PendingItemChange_accepted$_get_serializer_$ref_2vka68(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.h74_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, PendingItemChange_accepted$_get_annotations_$ref_21nmv8(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'PendingItemChange_accepted', VOID, VOID, [SerializableProperty()]);
    PendingItemChange_acceptedClass = $;
  }
  return PendingItemChange_acceptedClass;
}
var PendingItemChange_accepted_instance;
function PendingItemChange_accepted_getInstance() {
  if (PendingItemChange_accepted_instance === VOID)
    new (PendingItemChange_accepted())();
  return PendingItemChange_accepted_instance;
}
function PendingItemChange_approved$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(8);
}
function PendingItemChange_approved$_get_name_$ref_2edk2f() {
  return (p0) => p0.k20();
}
function PendingItemChange_approved$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[8];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function PendingItemChange_approved$_get_serializer_$ref_jfmcuo() {
  return (p0) => p0.j2j();
}
function PendingItemChange_approved$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(8);
}
function PendingItemChange_approved$_get_annotations_$ref_kq2cus() {
  return (p0) => p0.bz();
}
var PendingItemChange_approvedClass;
function PendingItemChange_approved() {
  if (PendingItemChange_approvedClass === VOID) {
    class $ {
      constructor() {
        PendingItemChange_approved_instance = this;
        var tmp = this;
        tmp.l74_1 = lazy(PendingItemChange_approved$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.m74_1 = lazy(PendingItemChange_approved$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.n74_1 = lazy(PendingItemChange_approved$annotations$delegate$lambda);
        this.o74_1 = null;
        this.p74_1 = 'null';
      }
      k20() {
        var tmp0 = this.l74_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, PendingItemChange_approved$_get_name_$ref_2edk2f(), null);
        return tmp0.f2();
      }
      b72(receiver) {
        return receiver.k72_1;
      }
      m2j(receiver) {
        return this.b72(receiver instanceof PendingItemChange() ? receiver : THROW_CCE());
      }
      q74(receiver, value) {
        return receiver.s72(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof PendingItemChange() ? receiver : THROW_CCE();
        return this.q74(tmp, (value == null ? true : typeof value === 'boolean') ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.m74_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, PendingItemChange_approved$_get_serializer_$ref_jfmcuo(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.n74_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, PendingItemChange_approved$_get_annotations_$ref_kq2cus(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'PendingItemChange_approved', VOID, VOID, [SerializableProperty()]);
    PendingItemChange_approvedClass = $;
  }
  return PendingItemChange_approvedClass;
}
var PendingItemChange_approved_instance;
function PendingItemChange_approved_getInstance() {
  if (PendingItemChange_approved_instance === VOID)
    new (PendingItemChange_approved())();
  return PendingItemChange_approved_instance;
}
function PendingItemChange_denied$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(9);
}
function PendingItemChange_denied$_get_name_$ref_etekvn() {
  return (p0) => p0.k20();
}
function PendingItemChange_denied$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[9];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function PendingItemChange_denied$_get_serializer_$ref_z1tlx0() {
  return (p0) => p0.j2j();
}
function PendingItemChange_denied$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(9);
}
function PendingItemChange_denied$_get_annotations_$ref_xtlxo8() {
  return (p0) => p0.bz();
}
var PendingItemChange_deniedClass;
function PendingItemChange_denied() {
  if (PendingItemChange_deniedClass === VOID) {
    class $ {
      constructor() {
        PendingItemChange_denied_instance = this;
        var tmp = this;
        tmp.r74_1 = lazy(PendingItemChange_denied$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.s74_1 = lazy(PendingItemChange_denied$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.t74_1 = lazy(PendingItemChange_denied$annotations$delegate$lambda);
        this.u74_1 = null;
        this.v74_1 = 'null';
      }
      k20() {
        var tmp0 = this.r74_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, PendingItemChange_denied$_get_name_$ref_etekvn(), null);
        return tmp0.f2();
      }
      b72(receiver) {
        return receiver.l72_1;
      }
      m2j(receiver) {
        return this.b72(receiver instanceof PendingItemChange() ? receiver : THROW_CCE());
      }
      w74(receiver, value) {
        return receiver.s72(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof PendingItemChange() ? receiver : THROW_CCE();
        return this.w74(tmp, (value == null ? true : value instanceof AccessAndFeedback()) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.s74_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, PendingItemChange_denied$_get_serializer_$ref_z1tlx0(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.t74_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, PendingItemChange_denied$_get_annotations_$ref_xtlxo8(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'PendingItemChange_denied', VOID, VOID, [SerializableProperty()]);
    PendingItemChange_deniedClass = $;
  }
  return PendingItemChange_deniedClass;
}
var PendingItemChange_denied_instance;
function PendingItemChange_denied_getInstance() {
  if (PendingItemChange_denied_instance === VOID)
    new (PendingItemChange_denied())();
  return PendingItemChange_denied_instance;
}
function PendingItemChange_withdrawn$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(10);
}
function PendingItemChange_withdrawn$_get_name_$ref_9jayic() {
  return (p0) => p0.k20();
}
function PendingItemChange_withdrawn$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[10];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function PendingItemChange_withdrawn$_get_serializer_$ref_apskj7() {
  return (p0) => p0.j2j();
}
function PendingItemChange_withdrawn$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(10);
}
function PendingItemChange_withdrawn$_get_annotations_$ref_6u9itz() {
  return (p0) => p0.bz();
}
var PendingItemChange_withdrawnClass;
function PendingItemChange_withdrawn() {
  if (PendingItemChange_withdrawnClass === VOID) {
    class $ {
      constructor() {
        PendingItemChange_withdrawn_instance = this;
        var tmp = this;
        tmp.x74_1 = lazy(PendingItemChange_withdrawn$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.y74_1 = lazy(PendingItemChange_withdrawn$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.z74_1 = lazy(PendingItemChange_withdrawn$annotations$delegate$lambda);
        this.a75_1 = null;
        this.b75_1 = 'null';
      }
      k20() {
        var tmp0 = this.x74_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, PendingItemChange_withdrawn$_get_name_$ref_9jayic(), null);
        return tmp0.f2();
      }
      b72(receiver) {
        return receiver.m72_1;
      }
      m2j(receiver) {
        return this.b72(receiver instanceof PendingItemChange() ? receiver : THROW_CCE());
      }
      c75(receiver, value) {
        return receiver.s72(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof PendingItemChange() ? receiver : THROW_CCE();
        return this.c75(tmp, (value == null ? true : value instanceof Instant()) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.y74_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, PendingItemChange_withdrawn$_get_serializer_$ref_apskj7(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.z74_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, PendingItemChange_withdrawn$_get_annotations_$ref_6u9itz(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'PendingItemChange_withdrawn', VOID, VOID, [SerializableProperty()]);
    PendingItemChange_withdrawnClass = $;
  }
  return PendingItemChange_withdrawnClass;
}
var PendingItemChange_withdrawn_instance;
function PendingItemChange_withdrawn_getInstance() {
  if (PendingItemChange_withdrawn_instance === VOID)
    new (PendingItemChange_withdrawn())();
  return PendingItemChange_withdrawn_instance;
}
function PendingItemChange_readBy$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(13);
}
function PendingItemChange_readBy$_get_name_$ref_6dsqo1() {
  return (p0) => p0.k20();
}
function PendingItemChange_readBy$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[13];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function PendingItemChange_readBy$_get_serializer_$ref_79k8va() {
  return (p0) => p0.j2j();
}
function PendingItemChange_readBy$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(13);
}
function PendingItemChange_readBy$_get_annotations_$ref_s8sjiu() {
  return (p0) => p0.bz();
}
var PendingItemChange_readByClass;
function PendingItemChange_readBy() {
  if (PendingItemChange_readByClass === VOID) {
    class $ {
      constructor() {
        PendingItemChange_readBy_instance = this;
        var tmp = this;
        tmp.d75_1 = lazy(PendingItemChange_readBy$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.e75_1 = lazy(PendingItemChange_readBy$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.f75_1 = lazy(PendingItemChange_readBy$annotations$delegate$lambda);
        this.g75_1 = emptySet();
        this.h75_1 = 'emptySet()';
      }
      k20() {
        var tmp0 = this.d75_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, PendingItemChange_readBy$_get_name_$ref_6dsqo1(), null);
        return tmp0.f2();
      }
      b72(receiver) {
        return receiver.p72_1;
      }
      m2j(receiver) {
        return this.b72(receiver instanceof PendingItemChange() ? receiver : THROW_CCE());
      }
      i75(receiver, value) {
        return receiver.s72(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof PendingItemChange() ? receiver : THROW_CCE();
        return this.i75(tmp, (!(value == null) ? isInterface(value, KtSet()) : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.e75_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, PendingItemChange_readBy$_get_serializer_$ref_79k8va(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.f75_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, PendingItemChange_readBy$_get_annotations_$ref_s8sjiu(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'PendingItemChange_readBy', VOID, VOID, [SerializableProperty()]);
    PendingItemChange_readByClass = $;
  }
  return PendingItemChange_readByClass;
}
var PendingItemChange_readBy_instance;
function PendingItemChange_readBy_getInstance() {
  if (PendingItemChange_readBy_instance === VOID)
    new (PendingItemChange_readBy())();
  return PendingItemChange_readBy_instance;
}
function PendingItemChange_published$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(14);
}
function PendingItemChange_published$_get_name_$ref_msy5hy() {
  return (p0) => p0.k20();
}
function PendingItemChange_published$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[14];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function PendingItemChange_published$_get_serializer_$ref_l5skql() {
  return (p0) => p0.j2j();
}
function PendingItemChange_published$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(14);
}
function PendingItemChange_published$_get_annotations_$ref_wtafmn() {
  return (p0) => p0.bz();
}
var PendingItemChange_publishedClass;
function PendingItemChange_published() {
  if (PendingItemChange_publishedClass === VOID) {
    class $ {
      constructor() {
        PendingItemChange_published_instance = this;
        var tmp = this;
        tmp.j75_1 = lazy(PendingItemChange_published$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.k75_1 = lazy(PendingItemChange_published$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.l75_1 = lazy(PendingItemChange_published$annotations$delegate$lambda);
        this.m75_1 = null;
        this.n75_1 = 'null';
      }
      k20() {
        var tmp0 = this.j75_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, PendingItemChange_published$_get_name_$ref_msy5hy(), null);
        return tmp0.f2();
      }
      b72(receiver) {
        return receiver.q72_1;
      }
      m2j(receiver) {
        return this.b72(receiver instanceof PendingItemChange() ? receiver : THROW_CCE());
      }
      c75(receiver, value) {
        return receiver.s72(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof PendingItemChange() ? receiver : THROW_CCE();
        return this.c75(tmp, (value == null ? true : value instanceof Instant()) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.k75_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, PendingItemChange_published$_get_serializer_$ref_l5skql(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.l75_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, PendingItemChange_published$_get_annotations_$ref_wtafmn(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'PendingItemChange_published', VOID, VOID, [SerializableProperty()]);
    PendingItemChange_publishedClass = $;
  }
  return PendingItemChange_publishedClass;
}
var PendingItemChange_published_instance;
function PendingItemChange_published_getInstance() {
  if (PendingItemChange_published_instance === VOID)
    new (PendingItemChange_published())();
  return PendingItemChange_published_instance;
}
//region block: exports
export {
  get_changeRequest as get_changeRequestajwchxq3dicy,
  get_created as get_created19174y6ey1rv2,
  get_itemNumber as get_itemNumber3opyx7hv723x5,
  preparePendingItemChangeFields as preparePendingItemChangeFields2n09ft4jr8tyv,
  get_priceChange as get_priceChangeq2x4gvw2nnoa,
  get_project as get_project1h2gisnyegd0y,
  get_updatedDescription as get_updatedDescription163szj45iknds,
};
//endregion

//# sourceMappingURL=PendingItemChangeFields.mjs.map
